import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Mechanism() {
  const steps = [{
    letter: 'O',
    title: 'Observo',
    desc: 'Aprende a observar la carta sin reaccionar al juego.'
  }, {
    letter: 'A',
    title: 'Asimilo',
    desc: 'Asimila la frecuencia del hito pactado en tu cuerpo.'
  }, {
    letter: 'S',
    title: 'Soy',
    desc: 'Expande tu ser y recupera el mando de tu simulación.'
  }];
  return <section className="py-12 sm:py-14 px-4 sm:px-6 lg:px-8 relative overflow-hidden bg-grid-pattern" data-id="element-83">
      {/* Central glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-84" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-85">
        <div className="text-center mb-12" data-id="element-86">
          <FadeIn data-id="element-87">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-88">
              El Protocolo <span className="text-gold-400" data-id="element-89">O→A→S</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto font-light" data-id="element-90">
              Esta es la tecnología de comando del Operador de la Lattice. Es el
              proceso técnico para dejar de ser el personaje que sufre y
              convertirte en el programador de tu propia simulación cuántica.
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-91">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-92" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative" data-id="element-93">
              <div className="flex flex-col items-center text-center group" data-id="element-94">
                <div className="w-24 h-24 rounded-full bg-navy-950 border border-gold-500/30 flex items-center justify-center mb-8 relative z-10 shadow-[0_0_30px_rgba(201,168,76,0.1)] group-hover:border-gold-400 transition-colors duration-500" data-id="element-95">
                  <div className="absolute inset-0 rounded-full bg-gold-500/10 scale-0 group-hover:scale-100 transition-transform duration-500 ease-out" data-id="element-96" />
                  <span className="text-4xl font-serif text-gold-400 relative z-10" data-id="element-97">
                    {step.letter}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-98">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-99">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}